import { useEffect, useRef } from 'react'
import { Marker, useMap } from 'react-leaflet'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import dayjs from 'dayjs'
import {
  authSelectors,
  chatCredentialsSelectors,
  markersSelectors,
  setIsSignIn,
  setPosts,
  setProfileItemId,
  setSelectedMarkerData,
  usersSelectors
} from 'store'
import {
  LOCATION_TYPE,
  MAX_ZOOM_LEVEL,
  UNSUPPORTED_MAX_ZOOM_LEVEL
} from 'utils/constants'
import { createMarkerColor } from 'utils/helpers'
import { v4 as uuid } from 'uuid'
import { ImagesPng } from 'assets/images'

export const MarkerItem = ({
  item,
  geoLoc,
  profileAvatar,
  isAuth
}) => {
  const {
    activeProfile,
    profileItemId
  } = useSelector(usersSelectors)
  const { isSignIn } = useSelector(authSelectors)
  const { xmppLiveLocation } = useSelector(chatCredentialsSelectors)
  const { selectedMarkerData } = useSelector(markersSelectors)
  let mouseDownOnMarkerRef = useRef(false)
  const map = useMap()

  const [searchParams, setSearchParams] = useSearchParams()

  const dispatch = useDispatch()

  const markerRef = useRef(null)
  // for debug
  // const testAvatar = 'https://i.natgeofe.com/n/548467d8-c5f1-4551-9f58-6817a8d2c45e/NationalGeographic_2572187_square.jpg'
  // console.log(markerAvatars)

  const liveLocCoord = [xmppLiveLocation?.lat, xmppLiveLocation?.lng]
  const iconMarker = createMarkerColor(
    dayjs(item?.last_accessed),
    profileAvatar ?? ImagesPng.DefaultImage,
    item?.is_friends,
    isAuth
  )
  const id = item?.id
  const idParam = searchParams.get('id')

  const markerPostForPopup = () => {
    if (item.coordinates[0] >= 84.8) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(markerRef?.current?._latlng, UNSUPPORTED_MAX_ZOOM_LEVEL)

      return 500
    }

    if (item.coordinates[0] >= 84.6) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(markerRef?.current?._latlng, 21)

      return 500
    }

    if (item.coordinates[0] >= 83.6) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(markerRef?.current?._latlng, 19)

      return 500
    }

    if (item.coordinates[0] >= 60) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(markerRef?.current?._latlng, 7)

      return 500
    }

    return 0
  }

  const handleClick = () => {
    if (isAuth) {
      dispatch(setPosts([]))

      dispatch(setProfileItemId(null))
      dispatch(setSelectedMarkerData(null))
      setSearchParams({ id })

      const finalTimeout = markerPostForPopup()
      setTimeout(() => {
        dispatch(setProfileItemId(item.id))
        dispatch(setSelectedMarkerData(item))
      }, finalTimeout)
    }
  }

  setTimeout(() => {
    if (
      +idParam === id
      && markerRef.current
      && +sessionStorage.getItem('id') === id
      && (
        profileItemId !== item.id
        || selectedMarkerData?.id !== item.id
      )
    ) {
      const finalTimeout = markerPostForPopup()
      setTimeout(() => {
        dispatch(setProfileItemId(item.id))
        dispatch(setSelectedMarkerData(item))
      }, finalTimeout)
    }
  }, 500)

  useEffect(() => {
    const marker = markerRef.current

    if (
      +idParam !== id
      && +sessionStorage.getItem('id') === id
      && markerRef.current
      && (
        localStorage.getItem('isNotifOpen') === null
        || localStorage.getItem('isNotifOpen') === 'false'
      )
    ) {
      try {
        document.querySelector('button[name="profile-pane-back-btn"]').click()
      } catch {
        //
      }
      setSearchParams({ id })
    } else if (
      isSignIn
      && activeProfile?.id === id
      && +idParam !== id
      && sessionStorage.getItem('id') === null
      && marker
      && sessionStorage.getItem('eventid') === null
    ) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(marker._latlng, MAX_ZOOM_LEVEL ?? 16)
      dispatch(setIsSignIn(false))
    }
  }, [])

  // Multiple mouse and touch events are used instead of only "click"
  // as a workaround for clicking markers that are outside of the bounds
  return (
    <Marker
      zIndexOffset={-99999}
      eventHandlers={{
        click: () => {
          if (item?.coordinates[0] < 84.5) {
            handleClick()
          }
        },
        mousedown: () => {
          mouseDownOnMarkerRef.current = true
        },
        mouseup: () => {
          if (mouseDownOnMarkerRef.current && item?.coordinates[0] >= 84.5) {
            handleClick()
          }

          mouseDownOnMarkerRef.current = false
        },
        mouseout: () => {
          mouseDownOnMarkerRef.current = false
        },
        touchStart: () => {
          mouseDownOnMarkerRef.current = true
        },
        touchEnd: () => {
          if (mouseDownOnMarkerRef.current && item?.coordinates[0] >= 84.5) {
            handleClick()
          }

          mouseDownOnMarkerRef.current = false
        },
        touchCancel: () => {
          mouseDownOnMarkerRef.current = false
        }
      }}
      key={uuid()}
      position={
        geoLoc
        && Number.isNaN(xmppLiveLocation.lat) === false
        && item.location_type[LOCATION_TYPE.LiveLocation] === 0
          ? liveLocCoord
          : item?.coordinates
      }
      icon={iconMarker}
      ref={markerRef}
      {...(isAuth ? { title: item?.id } : {})}
    />
  )
}
